module.exports = __webpack_public_path__ + "static/img/services9.52f76ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/services9.png
// module id = UfWB
// module chunks = 0